module.exports = __webpack_public_path__ + "img/18_64.16b890cb.png";